import Box from "@mui/material/Box";
import { IconButton } from "@mui/material";
import TextField from "@mui/material/TextField";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import styles from "./styles";
import useCss from "../../hooks/useCss";

interface Props {
  value?: string;
  handleChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleClear?: () => void;
  translatedSearchPlaceHolder?: string;
  [key: string]: unknown;
}

const SbuxInputSearch = ({
  value,
  handleChange,
  handleClear,
  translatedSearchPlaceHolder = "Search",
}: Props) => {
  const classes = useCss(styles);

  return (
    <Box className={classes.container}>
      <TextField
        variant="outlined"
        size="small"
        value={value}
        onChange={handleChange}
        autoComplete="off"
        placeholder={`${translatedSearchPlaceHolder}...`}
        InputProps={{
          startAdornment: <SearchIcon fontSize="medium" />,
          endAdornment: (
            <IconButton
              title="Clear"
              aria-label="Clear"
              size="medium"
              style={{ visibility: value ? "visible" : "hidden" }}
              onClick={handleClear}
            >
              <ClearIcon fontSize="medium" />
            </IconButton>
          ),
        }}
      />
    </Box>
  );
};

export default SbuxInputSearch;
